import { render } from "./NovaRequisicaoTabelas.vue?vue&type=template&id=b3ac7402&scoped=true"
import script from "./NovaRequisicaoTabelas.vue?vue&type=script&lang=js"
export * from "./NovaRequisicaoTabelas.vue?vue&type=script&lang=js"

import "./NovaRequisicaoTabelas.vue?vue&type=style&index=0&id=b3ac7402&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ac7402"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QTable,QImg,QInput,QIcon,QSelect,QCardSection,QTd,QBtn,QTr,QTh,QVirtualScroll,QPagination,QRadio});
